// import Vue from 'vue';
// import VueRouter from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import Calculator from './components/MyCalculator.vue';
import MyResult from './components/MyResult.vue';
import helloPage from './pages/helloPage.vue';
import myMakeDesc from './pages/myMakeDesc.vue';


const routes = [
  {
    path: '/helloPage',
    name: 'helloPage',
    component: helloPage,
  },
  {
    path: '/calc',
    name: 'Calculator',
    component: Calculator,
  },
  {
    path: '/',
    name: 'myMakeDesc',
    component: myMakeDesc,
  },
  {
    path: '/result',
    name: 'MyResult',
    component: MyResult,
    props: route => ({ result: route.query.result ? JSON.parse(route.query.result) : null }),
  },
];

// Create a router instance
const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;